/// <reference path="../../../../../rcwebmodels/reeferstatus.cs.d.ts" />

import * as React from 'react';
import { RCUtils } from './../../RCUtils';
import $ from 'jquery';
import * as Autosuggest from 'react-autosuggest';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import Select from 'react-select';
import UserRights from '../../actions/UserRights';
import "../../../node_modules/react-select/dist/react-select.css";
import uniq from 'lodash/uniq';

var Config: any = require('../../Config.json');

interface SearchState {
    Oemtypes: server.vRefOEMTypeUIModel[],
    RefCountry: server.RefCountryModel[],
    RefGeofences: string[],
    RefVessels: server.vesselsList[]; //WI-26881
    suggestionsFenceId: any[],
    suggestionsVesselId: any[], //WI-26881
    suggestionsVoyage: any[], //WI-26881
    suggestionsCalls: any[], //WI-26881
    targetId: string,
    Filters: server.ReeferSearchFilters,
    stayOpen: boolean,
    disabled: boolean,
    removeSelected: boolean,
    rtl: boolean,
    AssetStates: any[],
    CargoCareProfiles: any[];
    Pols: any[];//RCNG5588
    Pods: any[];//RCNG5588
}

const assetStates = [
    { label: "Active", value: 'A' },
    { label: "Disconnected", value: 'D' },
    { label: "Retired", value: 'R' },
];

export class ReeferStatusAdvanceSearch extends React.Component<any, SearchState> {
    constructor(props: any) {
        super(props);
        var customAttributesInfo = {};
        var filter: server.ReeferSearchFilters = {
            SelectedOem: '', SelectedCountry: '', SelectedGeofence: '', SelectedGeofenceInside: '', SelectedInterval: '', SelectedReefer: '', SelectedAssetStates: JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState,///RCNG-70, 
            SelectedVesselCode: '', StatusFilters: [], AllReefers: '', CustomAttributeFilters: customAttributesInfo, SelectedAssetTypes: '', SelectedBookingNumber: '', SelectedVesselCD: '', SelectedCall: '', SelectedVoyage: '' //WI-26881
            , SelectedCargoCareProfiles: '', SelectedPol: '', SelectedPod: '', SelectedCTProfileIds: []  //RCNG5588
        };
        
        if (this.props.stateData != null && this.props.stateData != undefined && this.props.stateData != null) {
            filter.SelectedOem = this.props.stateData.SelectedOem == null ? '' : this.props.stateData.SelectedOem;
            filter.SelectedAssetTypes = this.props.stateData.SelectedAssetTypes == null ? '' : this.props.stateData.SelectedAssetTypes;
            filter.SelectedAssetStates = this.props.stateData.SelectedAssetStates == null ? JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState : this.props.stateData.SelectedAssetStates; ///RCNG-70
            filter.SelectedCountry = this.props.stateData.SelectedCountry == null ? '' : this.props.stateData.SelectedCountry;
            filter.SelectedGeofence = this.props.stateData.SelectedGeofence == null ? '' : this.props.stateData.SelectedGeofence;
            filter.SelectedGeofenceInside = this.props.stateData.SelectedGeofenceInside == null ? '' : this.props.stateData.SelectedGeofenceInside;
            filter.SelectedInterval = this.props.stateData.SelectedInterval == null ? '' : this.props.stateData.SelectedInterval;
            filter.SelectedReefer = this.props.stateData.SelectedReefer == null ? '' : this.props.stateData.SelectedReefer;
            filter.SelectedVesselCode = this.props.stateData.SelectedVesselCode == null ? '' : this.props.stateData.SelectedVesselCode;
            filter.SelectedVoyage = this.props.stateData.SelectedVoyage == null ? '' : this.props.stateData.SelectedVoyage;//WI-26881
            filter.SelectedVesselCD = this.props.stateData.SelectedVesselCD == null ? '' : this.props.stateData.SelectedVesselCD;//WI-26881
            filter.SelectedCall = this.props.stateData.SelectedCall == null ? '' : this.props.stateData.SelectedCall;//WI-26881
            filter.SelectedBookingNumber = this.props.stateData.SelectedBookingNumber == null ? '' : this.props.stateData.SelectedBookingNumber;
            filter.StatusFilters = this.props.stateData.StatusFilters;
            filter.AllReefers = this.props.stateData.AllReefers == null ? '' : this.props.stateData.AllReefers;
            filter.CustomAttributeFilters = customAttributesInfo;
            filter.SelectedCargoCareProfiles = (this.props.SelectedCargoCareProfiles == "" || this.props.SelectedCargoCareProfiles == undefined) ? null : this.props.SelectedCargoCareProfiles;
            filter.SelectedPol = this.props.stateData.SelectedPol == null ? '' : this.props.stateData.SelectedPol;//RCNG5588
            filter.SelectedPod = this.props.stateData.SelectedPod == null ? '' : this.props.stateData.SelectedPod;//RCNG5588
        }

        this.state = {
            Oemtypes: [], RefGeofences: [], suggestionsFenceId: [], RefVessels: [], suggestionsVesselId: [], suggestionsVoyage: [], suggestionsCalls: [], //WI-26881
            targetId: '', RefCountry: [], Filters: filter, stayOpen: false, disabled: false, removeSelected: false, rtl: false, AssetStates: assetStates, CargoCareProfiles: [],Pols:[],Pods:[]
        };

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetGeofences')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GeofenceList[]>)
            .then(data => {
                if (data.length > 0) {
                    var fenceData = data.map(fence => fence.Tag);
                    this.setState({ RefGeofences: fenceData });
                }
            });
        //WI-26881:Start
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/Getvessels')
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.length > 0) {
                    //var VesselData = data.map(fence => fence.VesselCd);
                    //var uniqueVesselData = uniq(VesselData);
                    this.setState({ RefVessels: data });
                }
            });
        //WI-26881:End
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/OemTypes')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.vRefOEMTypeUIModel[]>)
            .then(data => {
                this.setState({ Oemtypes: data });
            });

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/CargoCareProfile/GetCargoCareCustomerProfilesAdvanceSearch');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                this.setState({ CargoCareProfiles: data });
            });
        //RCNG5588
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/CargoCareProfile/GetPOLDetails');
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<any[]>)
                .then(data => {
                    this.setState({ Pols: data });
                });
  
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/CargoCareProfile/GetPODDetails');
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<any[]>)
                .then(data => {
                    this.setState({ Pods: data });
                });
        

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/RefCountry')
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.RefCountryModel[]>)
            .then(data => {
                this.setState({ RefCountry: data });
            });
    }

    InsideGeofencechange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        if (Value == "---Select---")
            filters.SelectedGeofenceInside = null;
        else
            filters.SelectedGeofenceInside = Value;
        this.setState({
            Filters: filters
        });
    }

    Vesselcodechange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        filters.SelectedVesselCode = Value;
        this.setState({
            Filters: filters
        });
    }

    //Geofencechange(event: React.FormEvent<HTMLInputElement>) {
    //    var filters = this.state.Filters;
    //    var Value: string = event.currentTarget.value;
    //    filters.SelectedGeofence = Value;
    //    this.setState({
    //        Filters: filters
    //    });
    //}

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestionsFenceId: this.getFenceNameSuggestions(value)
        });
    };

    getFenceNameSuggestions(value) {
        var geofences = this.state.RefGeofences;
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : geofences.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestionsFenceId: []
        });
    };

    onChangeFenceId = (event, { newValue }) => {
        var filters = this.state.Filters;
        filters.SelectedGeofence = newValue;

        this.setState({
            Filters: filters,
            targetId: event.target.id
        });
    };

    renderSuggestion(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionValue(suggestion) {
        return suggestion;
    }
    //WI-26881:Start
    onSuggestionsFetchRequestedforvessel = ({ value }) => {
        this.setState({
            suggestionsVesselId: this.getvesselNameSuggestions(value)
        });
    };
    getvesselNameSuggestions(value) {
        //var vessels = this.state.RefVessels;
        var VesselData = this.state.RefVessels.map(fence => fence.VesselCd);
        var vessels = uniq(VesselData);
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : vessels.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };
    onSuggestionsClearRequestedforvessel = () => {
        this.setState({
            suggestionsVesselId: []
        });
    };
    onChangeVesselId = (event, { newValue }) => {
        var filters = this.state.Filters;
        filters.SelectedVesselCD = newValue;
        filters.SelectedVoyage = '';
        filters.SelectedCall = '';
        //$('#vesselID').addClass("fw-semibold");

        this.setState({
            Filters: filters,
            targetId: event.target.id
        });
        this.setState({
            suggestionsVoyage: this.getvoyageNameSuggestions(newValue)
        });
    };
    onChangcall = (event, { newValue }) => {
        var filters = this.state.Filters;
        filters.SelectedCall = newValue;
        //$('#vesselID').addClass("fw-semibold");

        this.setState({
            Filters: filters,
            targetId: event.target.id
        });
    };
    renderSuggestionVesselvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionVesselValue(suggestion) {
        return suggestion;
    }
    onSuggestionsFetchRequestedforvoyage = ({ value }) => {
        this.setState({
            suggestionsVoyage: this.voyageNameSuggestions(value)
        });
    };
    onSuggestionsFetchRequestedforcall = ({ value }) => {
        this.setState({
            suggestionsCalls: this.callSuggestions(value)
        });
    };
    callSuggestions(value) {
        if (this.state.Filters.SelectedVesselCD != "" && this.state.Filters.SelectedVesselCD != null && this.state.Filters.SelectedVoyage != "" && this.state.Filters.SelectedVoyage != null) {
            var VesselData = this.state.RefVessels;
            var targetValue = this.state.targetId;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.Filters.SelectedVesselCD
                && tag.VoyageNum === this.state.Filters.SelectedVoyage && tag.CallNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            //return test;
            return uniq(test.map(fence => fence.CallNum));
        }
        else
            return [];
    };
    voyageNameSuggestions(value) {
        if (this.state.Filters.SelectedVesselCD != "" && this.state.Filters.SelectedVesselCD != null) {
            var VesselData = this.state.RefVessels;
            //var vessels = uniq(VesselData);
            //var vessels = this.state.RefVessels;
            var targetValue = this.state.targetId;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.Filters.SelectedVesselCD
                && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            //return test;
            return uniq(test.map(fence => fence.VoyageNum));
        }
        else
            return [];
    };
    getvoyageNameSuggestions(value) {
        //var VesselData = this.state.RefVessels.map(fence => fence.VesselCd);
        var VesselData = this.state.RefVessels;
        //var vessels = uniq(VesselData);
        //var vessels = this.state.RefVessels;
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag =>
            tag.VesselCd.toLowerCase().slice(0, inputLength) === inputValue
        );
        //return test;
        return uniq(test.map(fence => fence.VoyageNum));
        //return (inputLength === 0 || this.state.RefVessels == null) ? [] : this.state.vesselData.PortOfDepartureList.filter(PortOfDeparture =>
        //    PortOfDeparture.toLowerCase().slice(0, inputLength) === inputValue
        //);
    };
    getcallSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.Filters.SelectedVesselCD
            && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.CallNum));
    };
    onSuggestionsClearRequestedforvoyage = () => {
        this.setState({
            suggestionsVoyage: []
        });
    };
    onSuggestionsClearRequestedforcall = () => {
        this.setState({
            suggestionsCalls: []
        });
    };
    onChangevoyage = (event, { newValue }) => {
        var filters = this.state.Filters;
        filters.SelectedVoyage = newValue;
        //$('#vesselID').addClass("fw-semibold");
        filters.SelectedCall = '';
        this.setState({
            Filters: filters,
            targetId: event.target.id
        });
        this.setState({
            suggestionsCalls: this.getcallSuggestions(newValue)
        });
        //this.getVoyageSuggestions(newValue);
    };
    renderSuggestionvoyagevalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionvoyageValue(suggestion) {
        return suggestion;
    }
    renderSuggestioncallvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestioncallValue(suggestion) {
        return suggestion;
    }
    //WI-26881:End
    ReeferIDschange(event: React.FormEvent<HTMLTextAreaElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        var commaValue = this.GetMultiLineCsv(Value);
        filters.SelectedReefer = commaValue;
        this.setState({
            Filters: filters
        });
    }

    BookingNumberchange(event: React.FormEvent<HTMLTextAreaElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        var commaValue = this.GetMultiLineCsv(Value);
        filters.SelectedBookingNumber = commaValue;
        this.setState({
            Filters: filters
        });
    }
    CargoCareProfileChange(value) {
        var filters = this.state.Filters;
        filters.SelectedCargoCareProfiles = value;
        this.setState({ Filters: filters });
    }

    AssetStateChange(value) {
        var filters = this.state.Filters;
        filters.SelectedAssetStates = value;
        if (value == "")
            $('#InventoryState .Select-control').addClass("MandatoryBorder");
        else
            $('#InventoryState .Select-control').removeClass("MandatoryBorder");
        this.setState({ Filters: filters });
    }

    Reeferchange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        filters.SelectedReefer = Value;
        this.setState({
            Filters: filters
        });
    }

    GetMultiLineCsv(value) {
        while (value.includes('\r') || value.includes('\n') || value.includes(';') || value.includes(' ')) {
            //while (value.includes('\r') || value.includes('\n') || value.includes(';')) {
            value = value.replace('\r'.toString(), ",");
            value = value.replace('\n'.toString(), ",");
            value = value.replace(';'.toString(), ",");
            value = value.replace(' '.toString(), ",");
        }

        while (value.includes(",,")) {
            value = value.replace(",,", ",");
        }
        return value;
    }

    Oemchange(event: React.FormEvent<HTMLSelectElement>) {

        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        if (Value == "---Select---")
            filters.SelectedOem = null;
        else
            filters.SelectedOem = Value;
        this.setState({
            Filters: filters
        });
    }

    Countrychange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        if (Value == "---Select---")
            filters.SelectedCountry = null;
        else
            filters.SelectedCountry = Value;
        this.setState({
            Filters: filters
        });
    }

    ReportingIntervalchange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        if (Value == "---Select---")
            filters.SelectedInterval = null;
        else
            filters.SelectedInterval = Value;
        this.setState({
            Filters: filters
        });
    }

    ClearFilter() {
        var filters = this.state.Filters;
        filters.SelectedCountry = "";
        filters.SelectedAssetStates = JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState;//RCNG-70//RCNG-59
        filters.SelectedGeofence = "";
        filters.SelectedGeofenceInside = "";
        filters.SelectedInterval = "";
        filters.SelectedOem = "";
        filters.SelectedReefer = "";
        filters.SelectedVesselCode = "";
        filters.SelectedBookingNumber = "";
        filters.SelectedVesselCD = "";//WI-26881
        filters.SelectedVoyage = "";//WI-26881
        filters.SelectedCall = "";//WI-26881
        filters.StatusFilters = [];
        filters.SelectedCargoCareProfiles = "";
        filters.SelectedPol = "";
        filters.SelectedPod = "";

        this.setState({
            Filters: filters
        });
    }
    //RCNG5588
    PolChange(value) {
        var filters = this.state.Filters;
        filters.SelectedPol = value;
        this.setState({ Filters: filters });
    }
    PodChange(value) {
        var filters = this.state.Filters;
        filters.SelectedPod = value;
        this.setState({ Filters: filters });
    }
    isNullOrEmpty(value) {
        return value == null || value === "";
    }

    ApplyFilter() {
        var filter = this.state.Filters;
        var that = this;
        this.state.Filters.AllReefers = "";
        this.state.Filters.StatusFilters = [];

        if (!this.isNullOrEmpty(this.state.Filters.SelectedCountry) || !this.isNullOrEmpty(this.state.Filters.SelectedGeofence) || !this.isNullOrEmpty(this.state.Filters.SelectedGeofenceInside)
            || !this.isNullOrEmpty(this.state.Filters.SelectedInterval) || !this.isNullOrEmpty(this.state.Filters.SelectedOem) || !this.isNullOrEmpty(this.state.Filters.SelectedReefer)
            || !this.isNullOrEmpty(this.state.Filters.SelectedVesselCode) || !this.isNullOrEmpty(this.state.Filters.SelectedBookingNumber) || !this.isNullOrEmpty(this.state.Filters.SelectedVesselCD) || !this.isNullOrEmpty(this.state.Filters.SelectedVoyage) || !this.isNullOrEmpty(this.state.Filters.SelectedCall)) { //WI-26881

            if (this.state.Filters.SelectedAssetStates == "" || this.state.Filters.SelectedAssetStates == null) {//RCNG-61
                PopupWindow.showErrorMessage('Error', "Please select Inventory State.");//RCNG-61           
                return;
            }
            else
                this.props.bindingReeferStatusGrid(this.state.Filters);
        }
        else {
            this.state.Filters.AllReefers = "All Assets";
            if (this.state.Filters.SelectedAssetStates == "" || this.state.Filters.SelectedAssetStates == null) {//RCNG-61
                PopupWindow.showErrorMessage('Error', "Please select Inventory State.");//RCNG-61           
                return;
            }
            else
                this.props.bindingReeferStatusGrid(this.state.Filters);
        }

        //this.props.bindingReeferStatusGrid(this.state.Filters);
    }

    componentDidMount() {
        $(document).ready(function () {
            $('.advance-search').bind('keypress', function (e) {
                if (e.keyCode === 13) {
                    $('#button_search').trigger('click');
                }
            });
        });
    }

    public render() {
        var Voyagedisabled: any;
        var Calldisabled: any;
        var CustomerTypeCd = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd;
        if (this.state.Filters.SelectedVesselCD != "" && this.state.Filters.SelectedVesselCD != null) {
            Voyagedisabled = false;
            Calldisabled = true;
        }
        else {
            Voyagedisabled = true;
            Calldisabled = true;
        }
        if (this.state.Filters.SelectedVoyage != "" && this.state.Filters.SelectedVoyage != null) {
            Calldisabled = false;
        }
        else {
            Calldisabled = true;
        }
        const { suggestionsFenceId, suggestionsVesselId, suggestionsVoyage, suggestionsCalls } = this.state;

        const FenceIdListinputProps = {
            id: 'geofenceID',
            placeholder: 'Geofence ID',
            value: this.state.Filters.SelectedGeofence,
            onChange: this.onChangeFenceId.bind(this)
        };
        const FenceIdListinputPropsforvessel = {
            id: 'vesselID',
            placeholder: 'Vessel',
            value: this.state.Filters.SelectedVesselCD,
            onChange: this.onChangeVesselId.bind(this)
        };
        const FenceIdListinputPropsforvoyage = {
            id: 'voyageNum',
            placeholder: 'Voyage',
            value: this.state.Filters.SelectedVoyage,
            onChange: this.onChangevoyage.bind(this),
            disabled: Voyagedisabled
        };
        const FenceIdListinputPropsforcall = {
            id: 'CallNum',
            placeholder: 'Call',
            value: this.state.Filters.SelectedCall,
            onChange: this.onChangcall.bind(this),
            disabled: Calldisabled
        };
        var cargoCareProfiles = this.state.CargoCareProfiles;
        if (cargoCareProfiles != undefined && cargoCareProfiles != null && cargoCareProfiles.length > 0) {

            var cargoCareProfilesOptions = cargoCareProfiles.map(function (CCP) {

                return (
                    { value: CCP.CargoCareCustomerProfileID, label: CCP.CargoCareCustomerProfileCode }
                );
            });
        }
        //RCNG5588
        var pols = this.state.Pols;
        if (pols != undefined && pols != null && pols.length > 0) {

            var polOptions = pols.map(function (POL) {

                return (
                    { value: POL.POL, label: POL.POL }
                );
            });
        }

        var pods = this.state.Pods;
        if (pods != undefined && pods != null && pods.length > 0) {

            var podOptions = pods.map(function (POD) {

                return (
                    { value: POD.POD, label: POD.POD }
                );
            });
        }
        var assetStates = this.state.AssetStates;
        if (assetStates != undefined && assetStates != null && assetStates.length > 0) {
            var assetStatesOptions = assetStates.map(function (states) {
                return (
                    { value: states.value, label: states.label }
                );
            });
        }

        return <div className='advance-search page-controls-container'>
            <form>
                <div className="row" >
                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end" >
                        <label className='col-form-label'>Reefer ID(s):</label>
                    </div>
                    <div className="col-md-5 col-sm-10 col-xs-9" >
                        <div className='form-group'>
                            <textarea id='txtReeferIds' className='form-control texarea-55' placeholder='Reefer ID(s)' onChange={e => this.ReeferIDschange(e)} value={this.state.Filters.SelectedReefer} ></textarea>
                        </div>
                    </div>
                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end" >
                        <label className='col-form-label'>Booking Number(s):</label>
                    </div>
                    <div className="col-md-5 col-sm-10 col-xs-9" >
                        <div className='form-group'>
                            <textarea id='txtBooking' className='form-control texarea-55' placeholder='Active Booking Number(s)' onChange={e => this.BookingNumberchange(e)} value={this.state.Filters.SelectedBookingNumber} ></textarea>
                        </div>
                    </div>
                </div>
                <div className="row mt-6" >

                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end" >
                        <label className='col-form-label'>OEM Type:</label>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-9">
                        <select className='form-select' id='selectOemType' onChange={e => this.Oemchange(e)} value={this.state.Filters.SelectedOem}>
                            <option>---Select---</option>
                            {
                                this.state.Oemtypes.map((oem, index) =>
                                    <option key={oem.OEMTypeCD + index} value={oem.OEMTypeCD}>{oem.DisplayName}</option>
                                )}
                        </select>
                    </div>
                    <div className="col-md-1 col-sm-2 col-xs-3 px-0 text-md-end" >
                        <label className='col-form-label'>Geofence Status:</label>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-9">
                        <select className='form-select' id='selectInsideGeofence' onChange={e => this.InsideGeofencechange(e)} value={this.state.Filters.SelectedGeofenceInside}>
                            <option>---Select---</option>
                            <option value="1">Inside Geofence Only</option>
                            <option value="0">Outside Geofence Only</option>
                        </select>
                    </div>


                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end" >
                        <label className='col-form-label'>Geofence:</label>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-9" >
                        <Autosuggest name="geofenceID" id="geofenceID"
                            suggestions={suggestionsFenceId}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                            getSuggestionValue={this.getSuggestionValue}
                            renderSuggestion={this.renderSuggestion}
                            inputProps={FenceIdListinputProps}
                            highlightFirstSuggestion={true}
                        />

                    </div>

                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end">
                        <label className='col-form-label'>Country:</label>
                    </div>


                    <div className="col-md-2 col-sm-4 col-xs-9" >

                        <select className='form-select' id='selectRefCountry' onChange={e => this.Countrychange(e)} value={this.state.Filters.SelectedCountry}>
                            <option>---Select---</option>
                            {
                                this.state.RefCountry.map((item, index) =>
                                    <option key={item.CountryCd + index} value={item.CountryCd}>{item.CountryName}</option>
                                )}
                        </select>
                    </div>


                </div>
                <div className="row mt-6" >

                    <div className="col-md-1 col-sm-2 col-xs-3 px-0 text-md-end">
                        <label className='col-form-label'>Reporting (min):</label>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-9">
                        <select className='form-select' id='selectReportingInterval' onChange={e => this.ReportingIntervalchange(e)} value={this.state.Filters.SelectedInterval}>
                            <option>---Select---</option>
                            <option>10</option>
                            <option>15</option>
                            <option>30</option>
                            <option>60</option>
                            <option>120</option>
                            <option>240</option>
                        </select>
                    </div>
                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end" >
                        <label className='col-form-label'>Vessel:</label>
                    </div>

                    <div className='col-md-2 col-sm-4 col-xs-9'>
                        <Autosuggest name="vesselID" id="vesselID"
                            suggestions={suggestionsVesselId}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforvessel}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforvessel}
                            getSuggestionValue={this.getSuggestionVesselValue}
                            renderSuggestion={this.renderSuggestionVesselvalue}
                            inputProps={FenceIdListinputPropsforvessel}
                            highlightFirstSuggestion={true}
                        />
                    </div>

                    <div className="col-md-1 col-sm-2 col-xs-3 px-0 text-md-end" >
                        <label className='col-form-label'>Voyage Number:</label>
                    </div>

                    <div className='col-md-2 col-sm-4 col-xs-9'>
                        <Autosuggest name="voyage" id="voyage"
                            suggestions={suggestionsVoyage}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforvoyage}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforvoyage}
                            getSuggestionValue={this.getSuggestionvoyageValue}
                            renderSuggestion={this.renderSuggestionvoyagevalue}
                            inputProps={FenceIdListinputPropsforvoyage}
                            highlightFirstSuggestion={true}
                        />
                    </div>



                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end d-none" >
                        <label className='col-form-label'>Vessel Code:</label>
                    </div>
                    <div className="col-md-2 col-sm-4 col-xs-9 d-none">

                        <input type='text' id='txtVesselCode' className='form-control' placeholder='Vessel Code' onChange={e => this.Vesselcodechange(e)} value={this.state.Filters.SelectedVesselCode} />

                    </div>

                    <div className="col-md-1 col-sm-2 col-xs-3 pe-0 text-md-end">
                        <label className='col-form-label'>Call Number:</label>
                    </div>

                    <div className='col-md-2 col-sm-4 col-xs-9'>
                        <Autosuggest name="Call" id="Call"
                            suggestions={suggestionsCalls}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforcall}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforcall}
                            getSuggestionValue={this.getSuggestioncallValue}
                            renderSuggestion={this.renderSuggestioncallvalue}
                            inputProps={FenceIdListinputPropsforcall}
                            highlightFirstSuggestion={true}
                        />
                    </div>

                </div>

                <div className="row mt-6" >
                    <div className="col-md-6" >
                        <div className="row" >

                            <div className="col-md-2 col-sm-2 col-xs-3 pe-0 text-md-end" >
                                <label className='col-form-label'>Inventory State:</label>
                            </div>
                            <div className="col-md-10 col-sm-4 col-xs-9" id="InventoryState">
                                <Select.Creatable
                                    closeOnSelect={!this.state.stayOpen}
                                    disabled={this.state.disabled}
                                    multi
                                    onChange={this.AssetStateChange.bind(this)}
                                    options={assetStatesOptions}
                                    placeholder="Inventory State"
                                    removeSelected={this.state.removeSelected}
                                    rtl={this.state.rtl}
                                    simpleValue
                                    value={this.state.Filters.SelectedAssetStates}
                                    minMenuHeight={30}
                                    maxMenuHeight={30}
                                    promptTextCreator={() => false}
                                />
                            </div>
                        </div>
                    </div>

                    {UserRights.checkMenuItemVisibility('247')[0] == "hidden" ? '' :
                        <div className="col-md-6" >
                           <div className="row" >
                                <div className="col-md-2 pe-0 text-md-end" >
                                    <span className='col-form-label'>CargoCare Profile(s):</span>
                            </div>
                            <div className="col-md-10" id="CargoCareProfile">
                                <Select.Creatable
                                    closeOnSelect={!this.state.stayOpen}
                                    disabled={this.state.disabled}
                                    multi
                                    onChange={this.CargoCareProfileChange.bind(this)}
                                    options={cargoCareProfilesOptions}
                                    placeholder="CargoCare Profile(s)"
                                    removeSelected={this.state.removeSelected}
                                    rtl={this.state.rtl}
                                    simpleValue
                                    value={this.state.Filters.SelectedCargoCareProfiles}
                                    minMenuHeight={30}
                                    maxMenuHeight={30}
                                    promptTextCreator={() => false}
                                />
                                </div> 
                            </div>
                        </div>}

                    <div className="col-md-6" >
                        <div className="row" >
                            
                            <div className="col-md-2 pe-0 text-md-end"  >
                                <label className='col-form-label'>POL:</label>
                            </div>
                            <div className="col-md-10" id="dvPOL">
                                <Select.Creatable
                                    closeOnSelect={!this.state.stayOpen}
                                    disabled={this.state.disabled}
                                    multi
                                    onChange={this.PolChange.bind(this)}
                                    options={polOptions}
                                    placeholder="POL"
                                    removeSelected={this.state.removeSelected}
                                    rtl={this.state.rtl}
                                    simpleValue
                                    value={this.state.Filters.SelectedPol}
                                    minMenuHeight={30}
                                    maxMenuHeight={30}
                                    promptTextCreator={() => false}
                                    onInputChange={inputValue =>
                                        (inputValue.length <= 30 ? inputValue : inputValue.substr(0, 30))
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6" >
                        <div className="row" >
                            <div className="col-md-2 pe-0 text-md-end" >
                                <label className='col-form-label'>POD:</label>
                            </div>
                            <div className="col-md-10" id="dvPOD">
                                <Select.Creatable
                                    closeOnSelect={!this.state.stayOpen}
                                    disabled={this.state.disabled}
                                    multi
                                    onChange={this.PodChange.bind(this)}
                                    options={podOptions}
                                    placeholder="POD"
                                    removeSelected={this.state.removeSelected}
                                    rtl={this.state.rtl}
                                    simpleValue
                                    value={this.state.Filters.SelectedPod}
                                    minMenuHeight={30}
                                    maxMenuHeight={30}
                                    promptTextCreator={() => false}
                                    onInputChange={inputValue =>
                                        (inputValue.length <= 30 ? inputValue : inputValue.substr(0, 30))
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-6" >
                    <div className="col-md-12 col-sm-12 col-xs-12" >
                        <div className='hstack gap-2 float-md-end'>
                            <button type='button' onClick={this.ClearFilter.bind(this)} className='btn btn-primary'>Clear</button>
                            <button type='button' id="button_search" onClick={this.ApplyFilter.bind(this)} className='btn btn-primary'>Search</button>                            
                        </div>
                    </div>

                </div>
            </form>
        </div>;
    }
}
